import { GlIcon } from '@gitlab/ui';
import { translate } from '../../../../../utils/i18n';
import { APPROVAL_TOOL_NAMES } from '../../../constants';
import BaseToolParams from './base_tool_params';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'RunCommandToolParams',
  components: {
    GlIcon,
    BaseToolParams
  },
  props: {
    toolName: {
      type: String,
      required: true
    },
    program: {
      type: String,
      required: false,
      default: ''
    },
    args: {
      type: String,
      required: false,
      default: ''
    },
    command: {
      type: String,
      required: false,
      default: ''
    },
    toolResponse: {
      type: Object,
      required: false,
      default: null
    },
    workingDirectory: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    formattedCommand() {
      if (this.toolName === APPROVAL_TOOL_NAMES.runCommand) {
        var _this$command;
        return (_this$command = this.command) !== null && _this$command !== void 0 && _this$command.length ? this.command : `${this.program} ${this.args}`;
      }
      return `git ${this.command} ${this.args}`;
    },
    withWorkingDirectory() {
      var _this$workingDirector;
      return (_this$workingDirector = this.workingDirectory) !== null && _this$workingDirector !== void 0 && _this$workingDirector.length ? `${this.workingDirectory}> ${this.formattedCommand}` : this.formattedCommand;
    },
    commandOutput() {
      var _this$toolResponse;
      return (_this$toolResponse = this.toolResponse) === null || _this$toolResponse === void 0 ? void 0 : _this$toolResponse.content;
    }
  },
  i18n: {
    SEE_COMMAND_OUTPUT: translate('RunCommandToolParams.ACCORDION_TITLE', 'Expand command output')
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-tool-params',{attrs:{"description":_vm.commandOutput,"custom-accordion-title":_vm.$options.i18n.SEE_COMMAND_OUTPUT}},[_c('div',{staticClass:"gl-flex gl-items-center gl-gap-3"},[_c('gl-icon',{staticClass:"gl-shrink-0",attrs:{"name":"terminal"}}),_vm._v(" "),_c('code',{staticClass:"gl-whitespace-pre-wrap gl-break-words"},[_vm._v(_vm._s(_vm.withWorkingDirectory))])],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
